module.exports = __webpack_public_path__ + "img/bianYaQi3.c8c8e49a.png";